import { owaDate } from 'owa-datetime';
import store from '../store/Store';
import { PUBLISHING_SETTINGS_ID, PUBLISHING_SETTINGS_NAME } from './getPublishSettingsVariables';
import type MeetingTypeExtension from '../services/schema/MeetingTypeExtension';
import type { PublishingSettingsExtension } from '../store/schema/PublishingSettingsExtension';
import createMeetingTypeExtension from '../services/createMeetingTypeExtension';
import { PublishStatus } from '../store/schema/BookWithMeOrganizerStore';

//If the publish settings extension does not exist, we create a default one
export default async function initializePublishSettings(isPublished: boolean) {
    const isPublishedForAttendee =
        store.BookingPagePublishedStatus == PublishStatus.Complete ||
        store.BookingPagePublishedStatus == PublishStatus.Published;
    let attendeeAndOrganizerPublishSyncTime = null;
    if (isPublishedForAttendee) {
        attendeeAndOrganizerPublishSyncTime = owaDate();
    }
    const nowUtc = owaDate();
    const publishingSettingsExtension: PublishingSettingsExtension = {
        isPublishedForAttendee,
        attendeeAndOrganizerPublishSyncTime,
        isPublished,
        whenLastUpdated: nowUtc,
        whenSettingsCreated: nowUtc,
    };
    const publishingSettingsExtensionAdditionalInformation = JSON.stringify(
        publishingSettingsExtension
    );
    const publishingSettingsRequestBody: MeetingTypeExtension = {
        itemId: PUBLISHING_SETTINGS_ID,
        displayName: PUBLISHING_SETTINGS_NAME,
        isPrivate: true,
        recipients: [],
        additionalInformation: publishingSettingsExtensionAdditionalInformation,
        preBuffer: store.meetingTypeEditState.preBuffer,
        postBuffer: store.meetingTypeEditState.postBuffer,
        excludeFromSelfService: store.meetingTypeEditState.excludeFromSelfService,
    };
    await createMeetingTypeExtension(publishingSettingsRequestBody);
}
